import { Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DoctorsSearch } from 'Images';

export const Title = () => {
  return (
    <>
      <Typography component={'h1'} variant='h3' color={'secondary'}>
        {Dictionary[DICTIONARY.Suppliers].doctorsSearchForm.title}
      </Typography>
      <Avatar
        src={DoctorsSearch}
        alt={''}
        sx={{ height: '110px', width: '254.66px' }}
      />
    </>
  );
};
